<template>
  <div class="resume">
    <resume-rooms />

    <resume-item>
      <template v-slot:label_sx>Costo camere</template>
      <template v-slot:label_dx>{{ '€ ' + pricing.base }}</template>
    </resume-item>

    <!-- extras chargeable -->
    <template v-for="(charges, index) in chargeable_extra" >
      <resume-extra-charges v-if="charges.condition" :extra="charges.data" :key="_uid+'chargeable'+index" />
    </template>

    <resume-item>
      <template v-slot:label_sx>Gestione e assistenza</template>
      <template v-slot:icon>
        <vb-icon
          class="ml-1"
          :name="'info'"
          :color="sass('gray-500')"
          :size="13"
          v-b-popover.hover.top="'Questi costi includono tasse e costi di gestione della prenotazione, oltre alla nostra assistenza clienti sempre a portata di click.'"
        />
      </template>
      <template v-slot:label_dx>{{ '€ ' + markup(pricing.book).markup }}</template>
    </resume-item>

    <resume-item class="resume__total">
      <template v-slot:label_sx>Totale</template>
      <template v-slot:label_dx>{{ '€ ' + pricing.live_price }}</template>
    </resume-item>

    <credit-alert
      v-if="activate_credit_alert && get_availability(pricing.live_price).show_credit_alert"
      :color="'danger'"
      class="resume__credit"
    />

    <!-- extras not_chargeable -->
    <template v-for="(charges, index) in not_chargeable_extra">
      <resume-extra-charges class="mt-4" v-if="charges.condition" :title="charges.title" :extra="charges.data" :key="_uid+'not-chargeable'+index" />
    </template>

    <!-- extras excluded e conditional -->
    <template v-for="(charges, index) in excluded_conditional" >
      <resume-extra-charges class="mt-4" v-if="charges.condition" :title="charges.title" :extra="charges.data" :key="_uid+'excluded-conditional'+index" />
    </template>

    <slot name="message"></slot>
  </div>
</template>

<script>
import { markup } from '@bookingv3/utilities'
import CreditAlert from "@components/atoms/credit-alert"
import ResumeItem from "@bookingv3/components/blocks/resume/resume-item"
import ResumeRooms from "@bookingv3/components/blocks/resume/resume-rooms"
import ResumeExtraCharges from "@bookingv3/components/blocks/resume/resume-extra-charges"

export default {
  name: 'resume',

  components: {
    'credit-alert': CreditAlert,
    'resume-item': ResumeItem,
    'resume-rooms': ResumeRooms,
    'resume-extra-charges': ResumeExtraCharges
  },

  props: {
    pricing: Object,
    activate_credit_alert: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
    }
  },

  computed: {

    extra_charges_data() {
      const {included, non_conditional, excluded, conditional} = this.pricing.extra_charges || {}

      return {
        chargeable_extra: [
          // extra included chargeable (pagina dettaglio)
          {
            condition: included && included.chargeable && included.chargeable.length,
            data: this.get_chargeable_data(included, 'chargeable')
          },
          // extra non_conditional chargeable (pagina checkout)
          {
            condition: non_conditional && non_conditional.chargeable && non_conditional.chargeable.length,
            data: this.get_chargeable_data(non_conditional, 'chargeable')
          }
        ],
        not_chargeable_extra: [
          // extra included not_chargeable (pagina dettaglio)
          {
            condition: included && included.not_chargeable && included.not_chargeable.length,
            title: "Da pagare in struttura:",
            data: this.get_chargeable_data(included, 'not_chargeable')
          },
          // non_conditional not_chargeable (pagina checkout)
          {
            condition: non_conditional && non_conditional.not_chargeable && non_conditional.not_chargeable.length,
            title: "Da pagare in struttura:",
            data: this.get_chargeable_data(non_conditional, 'not_chargeable')
          }
        ],
        excluded_conditional: [
          // extra excluded (pagina dettaglio)
          {
            condition: excluded && excluded.length,
            title: "Spese escluse:",
            data: this.get_chargeable_data(this.pricing.extra_charges, 'excluded')
          },
          // conditional (pagina dettaglio e checkout)
          {
            condition: conditional && conditional.length,
            title: "Spese condizionali:",
            data: this.get_chargeable_data(this.pricing.extra_charges, 'conditional')
          }
        ]
      }
    },

    chargeable_extra() {
      return this.extra_charges_data.chargeable_extra
    },

    not_chargeable_extra() {
      return this.extra_charges_data.not_chargeable_extra
    },

    excluded_conditional() {
      return this.extra_charges_data.excluded_conditional
    }

  },

  created() {
    this.markup = markup
  },

  mounted() {
  },

  methods: {

    get_chargeable_data(source, key) {
      if (source && source[key] && source[key].length) {
        return source[key]
      }
      return []
    }

  },
}
</script>

<style lang="scss" scoped>

  .resume {
    margin-bottom: $grid-gutter-width*2;

    &__total {
      padding-top: 10px;
      margin-top: 10px;
      border-top: 1px solid $gray-400;
      font-weight: $vb-font-weight-semibold;
    }

    &__credit {
      display: flex;
      justify-content: flex-end;
    }
  }

</style>